import React from "react";

import { enrichmentContextDescriptionForDisplay } from "../utils/enrichmentEntityDescriptions";



function sectionLabelClass(isInlineLight) {

  return isInlineLight

    ? "text-[10px] font-medium uppercase tracking-wide text-slate-500"

    : "text-[10px] font-medium uppercase tracking-wide text-slate-400";

}



function bodyClass(isInlineLight) {

  return isInlineLight

    ? "text-xs text-slate-700 leading-relaxed"

    : "text-xs text-slate-200 leading-relaxed";

}



/**

 * Review UI: one description block (usage in anchor app when present, else catalog).

 */

export default function EnrichmentContextNotes({

  row,

  anchorName = "",

  isInlineLight = false,

  /** "card" (dialog) | "compact" (queue panel) */

  variant = "compact",

  previewCatalogOnCreate = false,

  createEntityType = "",

  createEntityName = "",

}) {

  const description = enrichmentContextDescriptionForDisplay(row, {

    entityType: createEntityType,

    entityName: createEntityName,

    anchorName,

    previewOnCreate: previewCatalogOnCreate,

  });



  if (!description) return null;



  const label = previewCatalogOnCreate ? "Description (on create)" : "Description";



  const wrapperClass =

    variant === "card"

      ? isInlineLight

        ? "mt-2 rounded-lg border border-slate-200 bg-slate-50/90 px-3 py-2"

        : "mt-2 rounded-lg border border-slate-700/70 bg-slate-950/40 px-3 py-2"

      : "mt-2";



  return (

    <div className={wrapperClass}>

      <p className={sectionLabelClass(isInlineLight)}>{label}</p>

      <p className={`${bodyClass(isInlineLight)} mt-1 whitespace-pre-wrap`}>{description}</p>

    </div>

  );

}


